import _ from 'underscore';
import Backbone from 'backbone';
import Localizer from 'localizer';
import Loadable from 'utils/extensions/Loadable';
import SocialProfilePrivacy from 'models/user/SocialProfilePrivacy';
import ViewerSocialProfile from 'models/user/ViewerSocialProfile';
import ModelSynchronizer from 'utils/ModelSynchronizer';
import ToolTipView from 'views/utils/ToolTipView';
import templateHtml from 'templates/privacy/PrivacyAlertView.html';
import customFooterHtml from 'templates/privacy/PrivacyAlertFooterView.html';
import Preferences from 'models/preferences/Preferences';
import { privacyUpdatesRoleKey } from 'models/preferences/PreferencesMapping'; // Clean up ticket: CA-99172
import UsersPrivacySettings from 'models/user/UsersPrivacySettings';
import { PRIVACY_SETTINGS_ANALYTICS, pushUserPrivacySettingsChangeEventToAnalytics } from 'utils/UserPrivacyUtil';
import ReactModalPopupView from '../main/Modal/ReactModalPopupView';
import ModalPopupView from '../main/Modal/ModalPopupView';
import CustomPrivacyLevelsOptions from '../../../Privacy/Components/CustomPrivacyLevelsOptions';

var Events = {
    Closed: 'CLOSED',
    Ready: 'READY'
};

var PrivacyAlertView = Backbone.View.extend({
    footerTemplate: _.template(customFooterHtml),

    events: {
        'change select': 'onValueChanged',
        'click .btn-save-privacy': 'onSaveClicked',
        'click #editCustomPrivacyLevels': 'openCustomPrivacyModal'
    },

    propertyFiles: ['/privacy_alert/privacy_alert', '/settings/settings'],

    initialize: function(args) {
        this.userPreferences = args.userPreferences;
        this.requestType = args.requestType;

        this.changesMadeToProfileVisibility = false;
        this.changesMadeToActivityVisibility = false;
        this.profilePrivacyChanged = false;
        this.activityPrivacyChanged = false;

        var modelSynchronizer = new ModelSynchronizer();

        this.socialProfilePrivacy = new SocialProfilePrivacy({
            displayName: ViewerSocialProfile.get('displayName')
        });
        modelSynchronizer.addModel({
            model: this.socialProfilePrivacy,
            required: true
        });
        this.privacyUpdatesRole = new Preferences({ key: privacyUpdatesRoleKey }); // Clean up ticket: CA-99172
        modelSynchronizer.addModel({
            model: this.privacyUpdatesRole,
            required: true
        });
        this.usersPrivacySettings = new UsersPrivacySettings();
        modelSynchronizer.addModel({
            model: this.usersPrivacySettings,
            required: true,
            countError: true
        });

        modelSynchronizer.addEvent({
            model: modelSynchronizer,
            event: ModelSynchronizer.Events.ON_DOCUMENT_READY,
            required: true
        });
        modelSynchronizer.bind(ModelSynchronizer.Events.SYNCHRONIZED, this.onModelsFetched, this);

        // Fetch our models and collections
        modelSynchronizer.fetchModels();

        this.template = _.template(templateHtml);

        _.each(
            this.propertyFiles,
            function(propertyFile) {
                Localizer.loadPropertyFile(
                    propertyFile,
                    () => {
                        //if it is not synchronized then no need to render since it will render after synchronized
                        if (modelSynchronizer.synchronized()) {
                            this.render();
                        }
                    },
                    this
                );
            },
            this
        );
    },

    onModelsFetched: function() {
        if (this.privacyUpdatesRole.featureEnabled() && this.usersPrivacySettings) {
            // Clean up ticket: CA-99172 - remove else
            var usersActivityVisibility = this.usersPrivacySettings.getActivityCategoryAccessRule();

            this.displayModal =
                this.isProfilePrivate() ||
                (this.requestType === 'group' &&
                    (usersActivityVisibility === UsersPrivacySettings.Visibility.PRIVATE ||
                        usersActivityVisibility === UsersPrivacySettings.Visibility.CONNECTIONS)) ||
                (this.requestType === 'connection' &&
                    usersActivityVisibility === UsersPrivacySettings.Visibility.PRIVATE);
        } else {
            var profileVisibility = this.socialProfilePrivacy.get('profileVisibility');
            var activityVisibility = this.socialProfilePrivacy.get('activityVisibility');

            if (
                profileVisibility == SocialProfilePrivacy.Visibility.PRIVATE ||
                (this.requestType == 'group' &&
                    (activityVisibility == SocialProfilePrivacy.Visibility.PRIVATE ||
                        activityVisibility == SocialProfilePrivacy.Visibility.FOLLOWING)) ||
                (this.requestType == 'connection' && activityVisibility == SocialProfilePrivacy.Visibility.PRIVATE)
            ) {
                this.displayModal = true;
            } else {
                this.displayModal = false;
            }
        }
        this.trigger(Events.Ready);
    },

    renderOldFunctionality: function() {
        if (this.socialProfilePrivacy.get('profileVisibility') == SocialProfilePrivacy.Visibility.PRIVATE) {
            this.$('.control-profile-privacy').show();

            var profileToolTipView = new ToolTipView({
                el: this.$('.icon-help.profile-privacy-tip'),
                content: Localizer.localize('profile.privacy.description'),
                container: '#change-privacy-alert',
                placement: 'right'
            });
        } else {
            this.$('.control-profile-privacy').hide();
        }

        var activityVisibility = this.socialProfilePrivacy.get('activityVisibility');
        var isPrivate = activityVisibility == SocialProfilePrivacy.Visibility.PRIVATE;
        var isConnections = activityVisibility == SocialProfilePrivacy.Visibility.FOLLOWING;

        if (
            (this.requestType == 'group' && (isPrivate || isConnections)) ||
            (this.requestType == 'connection' && isPrivate)
        ) {
            this.$('#activity-privacy-options').val(activityVisibility);
            this.$('.control-activity-privacy').show();

            var activityToolTipView = new ToolTipView({
                el: this.$('.icon-help.activity-privacy-tip'),
                content: Localizer.localize('activity.privacy.description'),
                container: '#change-privacy-alert',
                placement: 'right'
            });
        } else {
            this.$('.control-activity-privacy').hide();
        }
    },

    isProfilePrivate: function() {
        let profileVisibility = this.usersPrivacySettings.getProfileCategoryAccessRule();

        return profileVisibility === UsersPrivacySettings.Visibility.PRIVATE;
    },

    renderPrivacyFunctionality: function() {
        let activityVisibility = this.usersPrivacySettings.getActivityCategoryAccessRule();

        if (this.isProfilePrivate() || this.changesMadeToProfileVisibility) {
            //we also check for this.changesMadeToProfileVisibility because on rerender - it will not show
            this.$('.control-profile-privacy').show();

            let profileToolTipView = new ToolTipView({
                el: this.$('.icon-help.profile-privacy-tip'),
                content: Localizer.localize('profile.privacy.description'),
                container: '#change-privacy-alert',
                placement: 'right'
            });
        } else {
            this.$('.control-profile-privacy').hide();
        }

        let activityPrivacyIsPrivate = activityVisibility === UsersPrivacySettings.Visibility.PRIVATE;
        let activityPrivacyIsConnections = activityVisibility === UsersPrivacySettings.Visibility.CONNECTIONS;

        if (
            (this.requestType === 'group' && (activityPrivacyIsPrivate || activityPrivacyIsConnections)) ||
            (this.requestType === 'connection' && activityPrivacyIsPrivate) ||
            this.changesMadeToActivityVisibility
        ) {
            //we also check for this.changesMadeToActivityVisibility because on rerender - it will not show
            this.$('#activity-privacy-options').val(activityVisibility);
            this.$('.control-activity-privacy').show();

            let activityToolTipView = new ToolTipView({
                el: this.$('.icon-help.activity-privacy-tip'),
                content: Localizer.localize('activity.privacy.description'),
                container: '#change-privacy-alert',
                placement: 'right'
            });
        } else {
            this.$('.control-activity-privacy').hide();
        }
    },

    render: function() {
        let profileVisibilityChange = this.usersPrivacySettings.getProfileCategoryAccessRule(),
            activityVisibilityChange = this.usersPrivacySettings.getActivityCategoryAccessRule();

        this.$el.html(
            this.template({
                Localizer: Localizer,
                userHasPrivacyUpdatesRole: this.privacyUpdatesRole.featureEnabled(),
                privacySettingsVisibility: UsersPrivacySettings.Visibility,
                preSelectedProfileVisibility: profileVisibilityChange,
                preSelectedActivityVisibility: activityVisibilityChange
            })
        );

        if (this.privacyUpdatesRole.featureEnabled() && this.usersPrivacySettings) {
            // Clean up ticket: CA-99172 - remove else
            this.renderPrivacyFunctionality();
        } else {
            this.renderOldFunctionality();
        }
    },

    setCustomFieldVisibility: function(remove) {
        this.changedCustomOptions = null;

        if (remove) {
            this.disableSaveOption(true);
            this.$('#editCustomPrivacyLevels').removeClass('hidden');
        } else {
            this.disableSaveOption(false);
            this.$('#editCustomPrivacyLevels').addClass('hidden');
        }
    },

    openCustomPrivacyModal: function(e) {
        e.preventDefault();
        e.stopPropagation();
        this.trigger(Events.Closed);

        if (this.customPrivacuModalView) {
            this.customPrivacuModalView.destroy();
        }
        this.customPrivacuModalView = new ReactModalPopupView({
            reactComponent: CustomPrivacyLevelsOptions,
            props: {
                activitySubcategoryPrivacySettings: this.usersPrivacySettings.getActivitySubcategoryPrivacySettings(),
                changeOptionValue: this.changeCustomOptionValue.bind(this)
            }
        });

        this.customPrivacyPopup = new ModalPopupView({
            view: this.customPrivacuModalView,
            onSaveButtonClicked: function() {
                this.onSaveCustomPrivacyChanges();
                return true;
            }.bind(this),
            customClasses: '',
            cancelTextKey: 'button_cancel',
            modalTitle: Localizer.localize('privacy_custom_levels')
        });

        this.customPrivacyPopup.postRemove = () => {
            this.trigger(Events.Ready);
            //since on .close() within ModalPopupView there is an this.unbind() we need to rebind events on opening the modal back
            this.delegateEvents();
            if (this.usersPrivacySettings.getActivityCategoryAccessRule() === UsersPrivacySettings.Visibility.CUSTOM) {
                let subcategoryPrivacySettings = this.usersPrivacySettings.getActivitySubcategoryPrivacySettings();
                let isAPrivacyTypeDifferent = UsersPrivacySettings.isValueDifferentInUserCustomPrivacy(
                    subcategoryPrivacySettings
                );

                this.disableSaveOption(!isAPrivacyTypeDifferent);
            }
        };

        setTimeout(() => {
            //render second modal only after the animation of the first one is done
            // since this is a inner view we do not have access to parent postRemove
            this.customPrivacyPopup.render();
            //disable save until something has changed
            this.customPrivacyPopup.disableConfirmationButton();
        }, 1000);
    },

    changeCustomOptionValue: function(changedOptions, newActivitySubcategoryPrivacySettings) {
        this.changedCustomOptions = changedOptions;
        let isAPrivacyTypeDifferent = UsersPrivacySettings.isValueDifferentInUserCustomPrivacy(
            newActivitySubcategoryPrivacySettings
        );

        if (!isAPrivacyTypeDifferent) {
            this.customPrivacyPopup.disableConfirmationButton();
        } else if (this.changedCustomOptions && this.changedCustomOptions.length) {
            this.customPrivacyPopup.enableConfirmationButton();
        }
    },

    onSaveCustomPrivacyChanges: function() {
        this.setupActivityCustomPrivacyChange(this.changedCustomOptions);
    },

    getDisplayModal: function() {
        return this.displayModal;
    },

    onValueChanged: function(evt) {
        var changed = evt.currentTarget;
        var value = changed.value;
        var changedObj = {};

        var fieldName = changed.name;
        changedObj[fieldName] = value;

        if (fieldName === 'activityVisibility') {
            if (this.privacyUpdatesRole.featureEnabled() && this.usersPrivacySettings) {
                // Clean up ticket: CA-99172 - remove else
                this.setupActivityVisibilityChange(value);
                if (value === UsersPrivacySettings.Visibility.CUSTOM) {
                    this.setCustomFieldVisibility(true);
                } else {
                    this.setCustomFieldVisibility();
                }
            } else {
                this.socialProfilePrivacy.set('activityVisibility', value);
            }
            this.activityPrivacyChanged = true;
        } else if (fieldName === 'profileVisibility') {
            if (this.privacyUpdatesRole.featureEnabled() && this.usersPrivacySettings) {
                // Clean up ticket: CA-99172 - remove else
                this.setupProfileVisibilityChange(value);
            } else {
                this.socialProfilePrivacy.set('profileVisibility', value);
            }
            this.profilePrivacyChanged = true;
        }
    },

    setupProfileVisibilityChange: function(value) {
        if (value) {
            this.changesMadeToProfileVisibility = true;
            this.usersPrivacySettings.setCategoryAccessRule(value, 'profilePrivacySettings');
            this.usersPrivacySettings.setSpecificPrivacyCustomSetting('profilePrivacySettings', 'user_profile', value);
            this.enableSaveIfActivityPrivacyIsProperlySet();
        }
    },

    enableSaveIfActivityPrivacyIsProperlySet: function() {
        if (this.usersPrivacySettings.getActivityCategoryAccessRule() === UsersPrivacySettings.Visibility.CUSTOM) {
            let subcategoryPrivacySettings = this.usersPrivacySettings.getActivitySubcategoryPrivacySettings();
            let isAPrivacyTypeDifferent = UsersPrivacySettings.isValueDifferentInUserCustomPrivacy(
                subcategoryPrivacySettings
            );

            this.disableSaveOption(!isAPrivacyTypeDifferent);
        } else {
            //if the value is properly set then enable save - enabled by not sending a true arg
            this.disableSaveOption();
        }
    },

    setupActivityVisibilityChange: function(value) {
        if (value) {
            this.changesMadeToActivityVisibility = true;
            if (value !== UsersPrivacySettings.Visibility.CUSTOM) {
                //if custom parent select do no set child activity to custom value
                let subcategoryPrivacySettings = this.usersPrivacySettings.getActivitySubcategoryPrivacySettings();
                subcategoryPrivacySettings.forEach((item) => {
                    this.usersPrivacySettings.setSpecificPrivacyCustomSetting(
                        'activityPrivacySettings',
                        item.privacySubcategoryType,
                        value
                    );
                });
            }

            this.usersPrivacySettings.setCategoryAccessRule(value, 'activityPrivacySettings');
        }
    },

    setupActivityCustomPrivacyChange: function(value) {
        if (value && value.length) {
            this.disableSaveOption(false);
            this.changesMadeToActivityVisibility = true;
            value.forEach((item) => {
                let valKey = Object.keys(item)[0];
                let val = item[valKey];
                this.usersPrivacySettings.setSpecificPrivacyCustomSetting('activityPrivacySettings', valKey, val);
            });
            this.usersPrivacySettings.setCategoryAccessRule(
                UsersPrivacySettings.Visibility.CUSTOM,
                'activityPrivacySettings'
            );
        }
    },

    disableSaveOption: function(shouldDisable) {
        let button = this.$el.parent().find('.btn.confirm');
        if (shouldDisable) {
            button.addClass('disabled').attr('disabled', true);
        } else {
            button.removeClass('disabled').attr('disabled', false);
        }
    },

    onSaveClicked: function() {
        if (this.profilePrivacyChanged || this.activityPrivacyChanged) {
            if (this.privacyUpdatesRole.featureEnabled() && this.usersPrivacySettings) {
                // Clean up ticket: CA-99172 - remove else
                this.usersPrivacySettings.save(null, { type: 'PUT', patch: true });
                if (this.profilePrivacyChanged) {
                    let profileChangedValue = this.usersPrivacySettings.getProfileCategoryAccessRule();
                    pushUserPrivacySettingsChangeEventToAnalytics(
                        PRIVACY_SETTINGS_ANALYTICS.USER_PROFILE_PRIVACY_SETTINGS_CHANGED,
                        `From Privacy Modal used in Connect to user or Groups Changed to: ${profileChangedValue}`
                    );
                }
                if (this.activityPrivacyChanged) {
                    let activityChangedValue = this.usersPrivacySettings.getActivityCategoryAccessRule();
                    pushUserPrivacySettingsChangeEventToAnalytics(
                        PRIVACY_SETTINGS_ANALYTICS.ACTIVITY_PRIVACY_SETTINGS_CHANGED,
                        `From Privacy Modal used in Connect to user or Groups Changed to: ${activityChangedValue}`
                    );
                }
            } else {
                this.socialProfilePrivacy.save();
            }
        }
    },

    /**
     * Updates the UserProfile stored in the user's session.
     * @param activityPrivacy
     */
    updateUserProfile: function(activityPrivacy) {
        jQuery.ajax({
            url: '/updateprofile/',
            type: 'POST',
            data: {
                defaultActivityPrivacy: activityPrivacy
            },
            success: function(result) {}
        });
    }
});

PrivacyAlertView.Events = Events;

export default PrivacyAlertView;
